import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"หนังสือมอบอำนาจ (Power of Attorney) — ร่าง รับรอง ใช้ในไทย/ต่างประเทศ","metaTitle":"หนังสือมอบอำนาจ (POA) ไทย/อังกฤษ + Notary + Apostille | NYC","metaDesc":"ร่างหนังสือมอบอำนาจ 2 ภาษา ตาม ป.พ.พ. มาตรา 797-832 พร้อม Notarial Attorney + MFA + Apostille ใช้ได้ทั่วโลก — ปรึกษาฟรีก่อนยื่นจริง ลดโอกาสเอกสารตีกลับ"},"en":{"h1":"Power of Attorney (POA) — Drafted, Notarised, Apostilled","metaTitle":"Thailand Power of Attorney (POA) — Notary + MFA + Apostille | NYC","metaDesc":"Bilingual POA drafted under Thai CCC §797-832 with Notarial Attorney, MFA legalisation and Hague Apost — Free consultation — message us for a same-day answer."}} as const;

export const Route = createFileRoute("/en/legal/power-of-attorney")({
  head: () => {
    const url = `${SEO_SITE}/en/legal/power-of-attorney`;
    const c = meta.en;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/en/legal/power-of-attorney", "en")},
        { name: "description", content: ctaDesc(c.metaDesc, "/en/legal/power-of-attorney", "en")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/en/legal/power-of-attorney", "en")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/en/legal/power-of-attorney", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_US" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/legal/power-of-attorney", "/en/legal/power-of-attorney")],
    };
  },
  component: () => <SubServicePage slug="legal/power-of-attorney" locale="en" />,
});
